import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Subject, takeUntil } from 'rxjs';
import { DisplayLabel } from '../../../../../shared/models/displayLabel';
import { RSJService } from '../../../../../shared/services/rsj.service';
import { RsjInstructionReservedDieDto } from '../../dto/rsj-instruction-reserved-die.dto';

@Component({
  selector: 'app-rsj-instruction-reserved-die',
  templateUrl: './rsj-instruction-reserved-die.component.html',
})
export class RsjInstructionReservedDieComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject();

  public reservedDieForm: UntypedFormGroup;
  public updated: boolean = false;
  public submitted: boolean = false;

  public useTitles: DisplayLabel[] = [];
  public stateTitles: DisplayLabel[] = [];

  @Input() public rsjReservedDie: RsjInstructionReservedDieDto;
  @Input() public disabled: boolean;
  @Input() public commentDieVisibility: boolean;

  constructor(
    private readonly formBuilder: UntypedFormBuilder,
    private readonly rsjService: RSJService,
  ) {}

  public async ngOnInit(): Promise<void> {
    await this.initList();
    this.initForm();
    this.initValueChangeHandlers();
  }

  public ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public onSubmit(): boolean {
    if (this.updated) {
      this.submitted = true;
    }
    return !this.updated || this.reservedDieForm.valid;
  }

  public getDto(): RsjInstructionReservedDieDto {
    if (this.reservedDieForm.valid) {
      this.rsjReservedDie = {
        useTitleId: this.reservedDieForm.controls.useTitleId.value,
        useTitleComment: this.reservedDieForm.controls.useTitleComment.value,
        stateTitleId: this.reservedDieForm.controls.stateTitleId.value,
        stateTitleComment: this.reservedDieForm.controls.stateTitleComment.value,
      } as RsjInstructionReservedDieDto;
    }
    return this.rsjReservedDie;
  }

  private async initList(): Promise<void> {
    this.useTitles = await this.rsjService.findUseTitles();
    this.stateTitles = await this.rsjService.findStateTitles();
  }

  private initForm(): void {
    this.reservedDieForm = this.formBuilder.group({
      useTitleId: [this.rsjReservedDie?.useTitleId],
      useTitleComment: [this.rsjReservedDie?.useTitleComment],
      stateTitleId: [this.rsjReservedDie?.stateTitleId],
      stateTitleComment: [this.rsjReservedDie?.stateTitleComment],
    });
    if (this.disabled) {
      this.reservedDieForm.disable({ emitEvent: false });
      if (this.commentDieVisibility) {
        this.reservedDieForm.controls.stateTitleComment.enable({ emitEvent: false });
      }
    }
  }

  private initValueChangeHandlers(): void {
    this.reservedDieForm.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(() => (this.updated = true));
  }
}
